import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_ctx.result.mfa && _ctx.result.mfa.resendCodeIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.resendCodeIn > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(" You can request a new code in "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.timeLeft), 1)
            ]))
          : (_openBlock(), _createBlock(_component_async_btn, {
              key: 1,
              task: _ctx.task,
              icon: "fa fa-refresh",
              label: "Didn't receive code? Resend code",
              flat: "",
              "no-caps": "",
              rounded: "",
              onClick: _ctx.resendCode
            }, null, 8, ["task", "onClick"]))
      ]))
    : _createCommentVNode("", true)
}